import { Injectable } from '@angular/core';
import { CommunicationConfigService, ConfigService } from '@argalis-apps/angular-global';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import * as TEST from './data-test';
import { MSession } from '@argalis-apps/models';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  constructor(
    private communicationConfigService: CommunicationConfigService,
    private http: HttpClient,
    private configService: ConfigService
  ) {}

  getPlanningBySession(
    idSession: number,
    idIntervenant: number = null,
    bSoustraitant = false
  ): Observable<any[]> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.get<MSession.IPlanning[]>(
        `${this.communicationConfigService.getApiUri()}/session-intervenant-extranet/${idSession}/${idIntervenant}/${bSoustraitant}`
      );
    }
    return null;
  }
  getSessionConsigne(idSession: number) {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.get<any>(
        `${this.communicationConfigService.getApiUri()}/session-consigne-extranet/${idSession}`
      );
    }
    return null;
  }

  getListOfSessionByIntervenant(
    idIntervenant: number,
    bOrganismeSoustraitant = false
  ): Observable<MSession.ISessionInfo[]> {
    if (this.configService.getOptions().useTestData !== true) {
      let params = new HttpParams();
      params = params.set('idIntervenant', (idIntervenant || 0).toString());
      params = params.set('bOrganismeSoustraitant', (bOrganismeSoustraitant || false).toString());
      return this.http.get<MSession.ISessionInfo[]>(
        `${this.communicationConfigService.getApiUri()}/session-list-extranet/intervenant`,
        { params }
      );
    }
    return null;
  }

  getIfUserAuthorizedToSession(idUser: number, idSession: number) {
    return this.http.get<boolean>(
      `${this.communicationConfigService.getApiUri()}/session-intervenant-extranet/${idSession}/${idUser}`
    );
  }

  getPresenceInfoBySession(idSession): Observable<MSession.IPresence[]> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.get<MSession.IPresence[]>(
        `${this.communicationConfigService.getApiUri()}/session-apprenant-presence/${idSession}`
      );
    }
    return null;
  }

  updatePresenceInfoBySession(requeteBody) {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.put<any>(
        `${this.communicationConfigService.getApiUri()}/session-apprenant-presence/`,
        requeteBody
      );
    }
    return null;
  }

  getEvaluationInfo(idSession): Observable<MSession.IEvaluation[]> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.get<MSession.IEvaluation[]>(
        `${this.communicationConfigService.getApiUri()}/session-evaluation-extranet/${idSession}`
      );
    }
    return null;
  }

  updateCompetenceInfo(bodyRequet: MSession.ISessionApprenantCompetences): Observable<any> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.put<MSession.IEvaluation[]>(
        `${this.communicationConfigService.getApiUri()}/session-evaluation-extranet/session-apprenant-competence`,
        bodyRequet
      );
    }
    return null;
  }

  updateEvaluationInfo(bodyRequet: MSession.IEvaluation): Observable<any> {
    if (this.configService.getOptions().useTestData !== true) {
      return this.http.put<any>(
        `${this.communicationConfigService.getApiUri()}/session-evaluation-extranet/session-apprenant`,
        bodyRequet
      );
    }
    return null;
  }

  getSessionPlanningExtranet(idIntervenant, bOrganismeSoustraitant, idSession) {
    let params = new HttpParams();
    params = params.set('idIntervenant', (idIntervenant || 0).toString());
    params = params.set('idSession', (idSession || 0).toString());
    params = params.set('bOrganismeSoustraitant', (bOrganismeSoustraitant || false).toString());
    return this.http.get<any>(`${this.communicationConfigService.getApiUri()}/session-rapport-extranet/rapport`, {
      params
    });
  }
  updateSessionIntervenantSatisfaction(body) {
    return this.http.put<any>(
      `${this.communicationConfigService.getApiUri()}/session-rapport-extranet/commentaire-rapport`,
      body
    );
  }

  getSessionHeader(idSession: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.communicationConfigService.getApiUri()}/session-header-extranet/${idSession}`);
  }
  getSessionSynthese(idSession: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-synthese-extranet/${idSession}`
    );
  }

  getHabilationBySession(idSession: number): Observable<{ habilitation: boolean; type: string }> {
    return this.http.get<{ habilitation: boolean; type: string }>(
      `${this.communicationConfigService.getApiUri()}/session-synthese-extranet/${idSession}/habilitation`
    );
  }
  updatecloseSession(body): Observable<any[]> {
    return this.http.put<any[]>(`${this.communicationConfigService.getApiUri()}/session-header-extranet/close`, body);
  }

  getSessionPrerequis(idSession: number): Observable<any[]> {
    let params = new HttpParams();
    params = params.set('idSession', (idSession || 0).toString());
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-prerequis-extranet/prerequis/${idSession}`
    );
  }

  getSessionApprenantPrerequis(idSession: number, idApprenant: number): Observable<any[]> {
    let params = new HttpParams();
    params = params.set('idSession', (idSession || 0).toString());
    params = params.set('idApprenant', (idApprenant || 0).toString());
    return this.http.get<any[]>(`${this.communicationConfigService.getApiUri()}/session-prerequis-extranet/apprenant`, {
      params
    });
  }

  updateSessionApprenantPrerequis(body) {
    return this.http.put<any>(`${this.communicationConfigService.getApiUri()}/session-prerequis-extranet/save`, body);
  }

  getSessionApprenantHabilitation(idSession: number) {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-habilitation-extranet/${idSession}`
    );
  }

  updateSessionApprenantHabilitation(idSessionApprenant: number, habilitation) {
    return this.http.put<any>(
      `${this.communicationConfigService.getApiUri()}/session-habilitation-extranet/${idSessionApprenant}`,
      { habilitation }
    );
  }

  // générer un numéro de cértificat caces
  generateCertif(idSession: number, idCategorie: number) {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-habilitation-extranet/${idSession}/categorie/${idCategorie}`
    );
  }

  // Sauvegarder les certificats caces
  saveCertificats(certificats): any {
    console.log('certificats', certificats);
    return this.http.post(
      `${this.communicationConfigService.getApiUri()}/session-habilitation-extranet/caces/certificats`,
      {
        certificats
      }
    );
  }

  saveTranche(tranche: any) {
    return this.http.post(
      `${this.communicationConfigService.getApiUri()}/session-planification/session/planification`,
      {
        tranche
      }
    );
  }

  deleteTranche(idPlanif: any, idUser: any) {
    return this.http.delete(
      `${this.communicationConfigService.getApiUri()}/session-planification/planification/delete/${idPlanif}/${idUser}`
    );
  }

  moducleChecker(module: any) {
    return this.http.get(`${this.communicationConfigService.getApiUri()}/session-module-admin/check-module/${module}`);
  }

  getSessionIntervenant(id_intervenant: any, id_session: any, b_ost: any) {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-intervenant/${id_intervenant}/${id_session}/${b_ost}`
    );
  }

  getClientSite(idSession: any) {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-planification/session/planification/sites/${idSession}`
    );
  }

  verifAJoutTranche(idSession: any) {
    return this.http.get<any[]>(
      `${this.communicationConfigService.getApiUri()}/session-planification/ajout-tranche/${idSession}`
    );
  }
}
